import { render, staticRenderFns } from "./GlobalNewButton.vue?vue&type=template&id=e3f93c90&scoped=true"
import script from "./GlobalNewButton.vue?vue&type=script&lang=js"
export * from "./GlobalNewButton.vue?vue&type=script&lang=js"
import style0 from "./GlobalNewButton.vue?vue&type=style&index=0&id=e3f93c90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3f93c90",
  null
  
)

export default component.exports